import React from "react";
import InvoicesView from "./InvoicesView";
import QuotationsView from "./QuotationsView";
import ProposalsView from "./ProposalsView";
import "./quickAccess.css";

function QuickAccessWorkspace({ activeTab = "invoice", role = "admin", initialSearch = "" }) {
  if (activeTab === "quotation" || activeTab === "quotations") {
    return <QuotationsView role={role} initialSearch={initialSearch} />;
  }

  if (activeTab === "proposals" || activeTab === "proposal") {
    return <ProposalsView role={role} initialSearch={initialSearch} />;
  }

  // Default: Invoices
  return <InvoicesView role={role} initialSearch={initialSearch} />;
}

export default QuickAccessWorkspace;
